import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import Label from '../../components/Label/Label';

export interface GridLabel {
  label: string;
  title: string;
  id?: string;
  isOptional?: boolean;
  type?: 'text' | 'progress' | 'Amount' | 'Status' | 'Link' | 'Success';
  link?: string;
  xs?: number;
  format?: string;
}

type Props = {
  labels: GridLabel[];
  labelSx?: any;
  titleSx?: any;
};

const GridLabels: FC<Props> = ({ labels, labelSx, titleSx }) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {labels?.map(({ label, title, id, isOptional, xs, type = 'text', link, format }) =>
        isOptional ? (
          ''
        ) : (
          <Grid item xs={xs ?? 6} key={id}>
            <Label
              labelSx={labelSx}
              type={type}
              format={format}
              titleSx={titleSx}
              label={label}
              title={title}
              link={link}
            />
          </Grid>
        )
      )}
    </>
  );
};

export default GridLabels;
